import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalizedErrorMessage } from '../../hooks/useLocalizedErrorMessage';
import { en } from '../../locales/en';
import { useGcsStore } from '../../store/useGcsStore';
import { AsyncAction } from '../../types/general/asyncAction';
import { Text } from '../general/Text';
import Dialog from './Dialog';

interface ConfirmSignOutDialogProps {
  gcsId: string;
  onClose: () => void;
}

function ConfirmSignOutDialog({ gcsId, onClose }: ConfirmSignOutDialogProps) {
  const getLocalizedErrorMessage = useLocalizedErrorMessage();
  const [signOutAction, setSignOutAction] = useState<AsyncAction>(AsyncAction.initial());
  const signOut = useGcsStore((state) => state.signOut);
  const disconnectAll = useGcsStore((state) => state.disconnectAll);
  const navigate = useNavigate();

  const onSignOutClicked = async () => {
    try {
      setSignOutAction(AsyncAction.loading());
      await signOut(gcsId);
      setSignOutAction(AsyncAction.success());
      onSignOutSuccess();
    } catch (error) {
      setSignOutAction(AsyncAction.failure(error));
    }
  };

  const onSignOutSuccess = () => {
    disconnectAll();
    onClose();
    navigate('/sign-in');
  };

  return (
    <Dialog
      title={en.confirmSignOutDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmSignOutDialog.signOutButton,
        callback: onSignOutClicked,
        isLoading: signOutAction.isLoading,
        backgroundColor: 'var(--color-danger)',
        foregroundColor: '#ffffff'
      }}
      errorText={signOutAction.isFailure ? getLocalizedErrorMessage(signOutAction.error) : undefined}
    >
      <div style={{ minWidth: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmSignOutDialog.body}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmSignOutDialog;
